/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		0:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "" + chunkId + ".bundle.js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/bundles/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	var Loader = __webpack_require__(5);
	
	document.body.classList.add("loading");
	var loader = new Loader();
	loader.startLoaderText();
	
	__webpack_require__.e/* nsure */(1, function (require) {
	    var telluric = __webpack_require__(7);
	    telluric.init();
	});
	
	
	var items = document.querySelectorAll(".talk__container .close, .social_icons .speaking");
	for (var x=0; x<items.length;x++){
	    items[x].addEventListener("click",function(e){
	        document.querySelector(".talk__container").classList.toggle("open");
	        document.querySelector(".hider").classList.toggle("open");
	        e.preventDefault();
	    });
	}
	
	
	document.querySelector(".hider").addEventListener("click",function(e){
	    document.querySelector(".talk__container").classList.remove("open");
	    document.querySelector(".hider").classList.remove("open");
	    e.preventDefault();
	});
	
	
	document.addEventListener('keydown', function(e) {
	    if (e.keyCode == 27) {
	        document.querySelector(".talk__container").classList.remove("open");
	        document.querySelector(".hider").classList.remove("open");
	    }
	});

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../node_modules/css-loader/index.js!../node_modules/sass-loader/index.js!./screen.scss", function() {
				var newContent = require("!!../node_modules/css-loader/index.js!../node_modules/sass-loader/index.js!./screen.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "#creatureTooltip{position:absolute;top:0;left:0;width:12rem;height:5rem;padding:.3rem;opacity:0;transition:opacity .3s ease-in;-webkit-clip-path:polygon(10% 0,100% 0,100% 80%,90% 100%,0 100%,0 20%)}#creatureTooltip .barContainer{position:relative;font-size:.7rem;height:1rem;line-height:1.1rem;text-align:center;width:100%;margin-bottom:.5rem;color:#fff;background:#a4a4a4;font-family:arial;-webkit-clip-path:polygon(10% 0,0 100%,90% 100%,100% 0)}#creatureTooltip .bar{width:100%;height:100%;transition:all .2s linear}#creatureTooltip .caption{font-family:sans-serif;color:#fff;font-size:10px;padding-left:1.5rem;padding-bottom:.2rem;padding-top:.3rem}#creatureTooltip .captions{position:absolute;width:100%;height:100%;left:0;top:0}#creatureTooltip .lifeBar .bar{background:#68964f}#creatureTooltip .energyBar .bar{background:#5f63b3}#creatureTooltip .estrusBar .bar{background:#45b347}#creatureTooltip .estrusBar.inEstrus .bar{background:#46b3aa}body{margin:0;background:#a1a3cc;overflow:hidden;color:#fff}canvas{width:100%;height:100%;top:0;left:0}.mainUi,canvas{position:absolute}.mainUi{width:120px;height:120px;bottom:3rem;right:3rem;display:none}.mainUi svg{width:100%;height:100%}.mainUi polygon{cursor:pointer;fill:rgba(79,79,84,.6);stroke:#fff;stroke-width:2}.mainUi image{pointer-events:none}#addFood{position:absolute;bottom:2rem;left:50%}#stats{display:none}#stats,canvas.gameView{position:absolute;top:0;left:0}canvas.gameView{width:100%;height:100%}.siteContainer{position:absolute;top:40%;left:50%;transform:translateX(-50%) translateY(-50%);transition:all 1s ease-out;z-index:10}@media (max-width:540px){.siteContainer{top:30%}}.siteContainer h1{font-family:Poiret One,cursive;margin:0;font-size:10rem}@media (max-width:540px){.siteContainer h1{font-size:6rem}}.siteContainer h2{font-size:1rem;position:relative;top:-1rem;left:11rem;font-family:Lato,sans-serif;margin:0;color:#fff}@media (max-width:540px){.siteContainer h2{left:1rem;top:1rem}}.siteContainer .social_icons{position:absolute;width:100%;text-align:center;bottom:-5rem;font-size:0}@media (max-width:540px){.siteContainer .social_icons{width:auto;bottom:-16rem;left:50%;transform:translateX(-50%);white-space:nowrap}}.siteContainer .social_icons .speaking{position:relative;top:-.25rem;width:5rem;height:2.5rem;overflow:hidden}@media (max-width:540px){.siteContainer .social_icons .speaking{width:4rem}}.siteContainer .social_icons .speaking svg{position:relative;width:5rem;height:4.5rem}@media (max-width:540px){.siteContainer .social_icons .speaking svg{width:4rem}}.siteContainer .social_icons .speaking svg path{transition:all .1s ease-in;fill:#f0b58c}.siteContainer .social_icons .speaking:hover svg path{fill:#fcefe6}.siteContainer .social_icons a{display:inline-block;font-size:2.5rem;margin-left:2rem;transition:all .1s ease-in}@media (max-width:540px){.siteContainer .social_icons a{font-size:2rem}}.siteContainer .social_icons a:first-child{margin-left:0}.siteContainer .social_icons a:hover{text-decoration:none;color:#fcefe6}.siteContainer a{color:#f0b58c;text-decoration:none}.siteContainer a:hover{text-decoration:underline}.loaderContainer{position:absolute;z-index:100;left:50%;bottom:10%;opacity:0;transform:translateX(-50%) translateY(-50%);transition:all .3s ease-in}.loaderContainer .loader{position:absolute;width:15rem;height:15rem;left:50%;top:50%;transform:translateX(-50%) translateY(-50%) rotate(-90deg) scaleX(-.5) scaleY(.5)}.loaderContainer .loader div{position:absolute;left:40%;width:.5rem;height:.5rem;background:#fff;border-radius:1rem;opacity:0}.loaderContainer .loader div.done:nth-child(n){animation:none;opacity:1}.loaderContainer .loader div:first-child{top:0;transition:all 1s 0s;background:#fdb37f;animation:dna_rotate 2s 0s infinite ease-in-out}.loaderContainer .loader div:nth-child(2){top:.6rem;transition:all 1s .1s;animation:dna_rotate 2s 1.1s infinite ease-in-out}.loaderContainer .loader div:nth-child(3){top:1.2rem;transition:all 1s .2s;background:#fdb37f;animation:dna_rotate 2s .2s infinite ease-in-out}.loaderContainer .loader div:nth-child(4){top:1.8rem;transition:all 1s .3s;animation:dna_rotate 2s 1.3s infinite ease-in-out}.loaderContainer .loader div:nth-child(5){top:2.4rem;transition:all 1s .4s;background:#fdb37f;animation:dna_rotate 2s .4s infinite ease-in-out}.loaderContainer .loader div:nth-child(6){top:3rem;transition:all 1s .5s;animation:dna_rotate 2s 1.5s infinite ease-in-out}.loaderContainer .loader div:nth-child(7){top:3.6rem;transition:all 1s .6s;background:#fdb37f;animation:dna_rotate 2s .6s infinite ease-in-out}.loaderContainer .loader div:nth-child(8){top:4.2rem;transition:all 1s .7s;animation:dna_rotate 2s 1.7s infinite ease-in-out}.loaderContainer .loader div:nth-child(9){top:4.8rem;transition:all 1s .8s;background:#fdb37f;animation:dna_rotate 2s .8s infinite ease-in-out}.loaderContainer .loader div:nth-child(10){top:5.4rem;transition:all 1s .9s;animation:dna_rotate 2s 1.9s infinite ease-in-out}.loaderContainer .loader div:nth-child(11){top:6rem;transition:all 1s 1s;background:#fdb37f;animation:dna_rotate 2s 1s infinite ease-in-out}.loaderContainer .loader div:nth-child(12){top:6.6rem;transition:all 1s 1.1s;animation:dna_rotate 2s 2.1s infinite ease-in-out}.loaderContainer .loader div:nth-child(13){top:7.2rem;transition:all 1s 1.2s;background:#fdb37f;animation:dna_rotate 2s 1.2s infinite ease-in-out}.loaderContainer .loader div:nth-child(14){top:7.8rem;transition:all 1s 1.3s;animation:dna_rotate 2s 2.3s infinite ease-in-out}.loaderContainer .loader div:nth-child(15){top:8.4rem;transition:all 1s 1.4s;background:#fdb37f;animation:dna_rotate 2s 1.4s infinite ease-in-out}.loaderContainer .loader div:nth-child(16){top:9rem;transition:all 1s 1.5s;animation:dna_rotate 2s 2.5s infinite ease-in-out}.loaderContainer .loader div:nth-child(17){top:9.6rem;transition:all 1s 1.6s;background:#fdb37f;animation:dna_rotate 2s 1.6s infinite ease-in-out}.loaderContainer .loader div:nth-child(18){top:10.2rem;transition:all 1s 1.7s;animation:dna_rotate 2s 2.7s infinite ease-in-out}.loaderContainer .loader div:nth-child(19){top:10.8rem;transition:all 1s 1.8s;background:#fdb37f;animation:dna_rotate 2s 1.8s infinite ease-in-out}.loaderContainer .loader div:nth-child(20){top:11.4rem;transition:all 1s 1.9s;animation:dna_rotate 2s 2.9s infinite ease-in-out}.loaderContainer .loader div:nth-child(21){top:12rem;transition:all 1s 2s;background:#fdb37f;animation:dna_rotate 2s 2s infinite ease-in-out}.loaderContainer .loader div:nth-child(22){top:12.6rem;transition:all 1s 2.1s;animation:dna_rotate 2s 3.1s infinite ease-in-out}.loaderContainer .loader div:nth-child(23){top:13.2rem;transition:all 1s 2.2s;background:#fdb37f;animation:dna_rotate 2s 2.2s infinite ease-in-out}.loaderContainer .loader div:nth-child(24){top:13.8rem;transition:all 1s 2.3s;animation:dna_rotate 2s 3.3s infinite ease-in-out}.loaderContainer .loader div:nth-child(25){top:14.4rem;transition:all 1s 2.4s;background:#fdb37f;animation:dna_rotate 2s 2.4s infinite ease-in-out}.loaderContainer .loader div:nth-child(26){top:15rem;transition:all 1s 2.5s;animation:dna_rotate 2s 3.5s infinite ease-in-out}.loaderContainer.done .loader{height:20rem}.loaderContainer.done .loader div:first-child{top:0;left:25%}.loaderContainer.done .loader div:nth-child(2){top:2rem;left:25%}.loaderContainer.done .loader div:nth-child(3){top:4rem;left:25%}.loaderContainer.done .loader div:nth-child(4){top:6rem;left:25%}.loaderContainer.done .loader div:nth-child(5){top:8rem;left:25%}.loaderContainer.done .loader div:nth-child(6){top:10rem;left:25%}.loaderContainer.done .loader div:nth-child(7){top:12rem;left:25%}.loaderContainer.done .loader div:nth-child(8){top:14rem;left:25%}.loaderContainer.done .loader div:nth-child(9){top:16rem;left:25%}.loaderContainer.done .loader div:nth-child(10){top:18rem;left:25%}.loaderContainer.done .loader div:nth-child(11){top:20rem;left:25%}.loaderContainer.done .loader div:nth-child(n){animation:none;border-radius:0;height:2rem;width:4rem;margin:0;background:#fff;opacity:1;transform:scale(1);z-index:5}.loaderContainer.done .loader div:first-child{border-top-left-radius:5rem;border-top-right-radius:5rem}.loaderContainer.done .loader div:nth-child(10){border-bottom-left-radius:5rem;border-bottom-right-radius:5rem}.loaderContainer.done .loader div:nth-child(n+11){opacity:0}.loaderContainer.done .loader div:nth-child(11){top:5%;border-top-left-radius:5rem;border-top-right-radius:5rem}.loaderContainer.done .loader div:nth-child(11),.loaderContainer.done .loader div:nth-child(12){opacity:1;left:38%;background-color:#fdb37f;width:5rem;height:3rem;z-index:2;transform:translateX(-50%) translateY(-50%)}.loaderContainer.done .loader div:nth-child(12){top:95%;border-bottom-left-radius:5rem;border-bottom-right-radius:5rem}@keyframes dna_rotate{0%{opacity:1;transform:scale(1);left:40%;z-index:0}25%{opacity:1;transform:scale(1.8)}50%{opacity:1;left:60%;z-index:1;transform:scale(1)}75%{opacity:1;transform:scale(.5)}to{opacity:1;left:40%;z-index:0;transform:scale(1)}}@keyframes jello{0%,1.85%,to{transform:none}3.7%{transform:skewX(-12.5deg) skewY(-12.5deg)}5.55%{transform:skewX(6.25deg) skewY(6.25deg)}7.4%{transform:skewX(-3.125deg) skewY(-3.125deg)}9.25%{transform:skewX(1.5625deg) skewY(1.5625deg)}11.1%{transform:skewX(-.78125deg) skewY(-.78125deg)}12.95%{transform:skewX(.39062deg) skewY(.39062deg)}14.8%{transform:skewX(-.19531deg) skewY(-.19531deg)}}.loaderContainer .loader{left:40%;transition:all 1s ease-in}.loaderContainer .caption{position:absolute;width:25rem;top:2.3rem;left:50%;font-family:Lato,sans-serif;text-align:center;font-size:.8rem;letter-spacing:.18rem;transform:translateX(-50%) translateY(-50%);transition:all .3s ease-in}.loaderContainer.alternate .loader div:nth-child(odd){background:#502228}.loaderContainer.alternate .loader div:nth-child(2n){background:#41485a}.loaderContainer .caption.waitForDone{opacity:0;top:-.8rem}.loaderContainer.done{cursor:pointer;animation:jello 4s infinite 5s}.loaderContainer.done .loader div{transition-delay:0s}.loaderContainer.done .caption{top:-.8rem;letter-spacing:.2rem;z-index:10;color:#000;opacity:.6;font-weight:700}.loaderContainer.done:hover .caption{color:#fff;opacity:1}.loaderContainer.done:hover .loader div:nth-child(n){background:#fdb37f}.loaderContainer.done:hover .loader div:nth-child(11),.loaderContainer.done:hover .loader div:nth-child(12){background:#fff}.talk__container{width:42rem;max-height:100vh;position:absolute;top:50%;left:50%;transform:translateX(-50%) translateY(-50%);background:#000;padding:4rem;border-radius:1rem;font-family:Lato,sans-serif;z-index:200;box-sizing:border-box;overflow-y:auto;opacity:0;transition:all .3s ease-in;pointer-events:none}@media (max-width:540px),(min-width:541px) and (max-width:1099px){.talk__container{top:0;left:0;width:100%;height:100%;transform:translateX(0) translateY(0);padding:1rem;border-radius:0}}.talk__container.open{opacity:1;pointer-events:all}.talk__container .talk__header{font-size:1.7rem;margin-bottom:.8rem;padding-left:.6rem}.talk__container .talk__section{display:inline-block;margin-top:1rem;padding:0 .6rem;border-radius:.3rem;color:#57617b}.talk__container .talk{margin:1rem 0;padding-left:.6rem}.talk__container .talk__date{display:inline;font-size:.6rem}.talk__container .close{position:absolute;width:1rem;height:1rem;text-align:center;background-color:hsla(0,0%,100%,.2);right:1rem;top:1rem;padding:.6rem;border-radius:3rem;font-size:.9rem;opacity:1;pointer-events:all;cursor:pointer}.talk__container .close:hover{background-color:hsla(0,0%,100%,.3)}.talk__container a{color:#f0b58c;text-decoration:none}.talk__container a:hover{text-decoration:none;color:#fcefe6}.hider{position:fixed;top:0;left:0;bottom:0;right:0;background:rgba(0,0,0,.8);z-index:50;opacity:0;pointer-events:none;transition:all .3s ease-in}.hider.open{pointer-events:all;opacity:1}#toast{left:50%;padding:1rem;border-radius:1rem;min-width:5rem;transform:translateX(-50%);background:rgba(0,0,0,.6);color:#fff;font-size:.8rem;text-align:center;opacity:0;pointer-events:none}#explain,#toast{position:absolute;bottom:2rem;font-family:Lato,sans-serif;z-index:100;transition:all .3s ease-in}#explain{display:none;right:2rem;width:2rem;height:2rem;overflow:hidden;border-radius:1.5rem;background-color:rgba(0,0,0,.7)}#explain .close{opacity:0;pointer-events:none}#explain .qmark{position:absolute;font-weight:700;text-align:center;width:100%;height:100%;line-height:2rem;cursor:pointer;border-radius:1.5rem;transition:all .3s ease-in}#explain .qmark:hover{background-color:hsla(0,0%,100%,.2)}#explain .content{max-height:0;padding:1rem;overflow:hidden;min-width:20rem;transition:all .3s ease-in}#explain .content h4{margin:0}#explain.open{right:calc(50% - 15rem);bottom:calc(50% - 10rem);width:30rem;height:20rem;overflow:visible}#explain.open .qmark{opacity:0;pointer-events:none}#explain.open .close{position:absolute;width:1rem;height:1rem;text-align:center;background-color:hsla(0,0%,100%,.2);right:1rem;top:1rem;padding:.6rem;border-radius:3rem;font-size:.9rem;opacity:1;pointer-events:all;cursor:pointer}#explain.open .close:hover{background-color:hsla(0,0%,100%,.3)}#explain.open .content{max-height:100rem;margin:2rem 0;font-family:Lato,sans-serif}.ingame .loaderContainer,.ingame .siteContainer{opacity:0;pointer-events:none}.ingame #explain{display:block}.loading .loaderContainer{opacity:1}", ""]);
	
	// exports


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var WebUtils = __webpack_require__(6);
	
	var loadingMessages = [
	    "Plagiarising Hearthstone",
	    "Thinking of funny things to write here",
	    "Making sure you don't get bored",
	    ["Knock knock", "Who's there", "A self aware test to pass loading time"],
	    ["Hello Dave.", "Wait, your name isn't Dave?", "I was sure I wrote your name here somewhere", "Oh here it is", "Funny you don't look like a Steve"],
	    "Sorry to keep you waiting",
	    ["It's going to be worth it", "I promise", "Pinky swear"],
	    "Anything is possible at Zombo... err... opherv.com",
	    "Verbing adjectives",
	    ["Gloating", "Did I say Gloating? I meant loading"],
	    ["Downloading required file","Ooops, wrong file", "Pffft.. 'required'. It's all subjective anyhow"],
	    ["This shouldn't take long at all", "(I think)"],
	    "How about that weather we're having?",
	    ["You know - It's not easy being a loading bar", "The hours are long", "The pay sucks", "Nobody appreciates what you do", "Everybody wants you to go away"],
	    "Constructing additional pylons",
	    "Placing the princesss in another castle",
	    "Loading",
	    "Downloading files",
	    "Retrieving assets",
	    "Compiling code",
	    "Visualizing models",
	    "Computing physics"
	];
	
	var instance;
	
	var Loader = function(){
	    this.currentMessageIndex = null;
	    this.currentMessageSequenceIndex = null;
	    this.messageEl = document.querySelector(".loaderContainer .caption");
	    instance = this;
	};
	
	Loader.getInstance = function(){
	    return instance;
	};
	
	Loader.prototype.startLoaderText = function(){
	    var that = this;
	
	    var randomTimeout = 2 + Math.random() * 5;
	    //todo ugly - fix
	    this.changeMessageTimeout = setTimeout(doChangeMessage,9000);
	
	    function doChangeMessage(){
	        that.nextMessage();
	        randomTimeout = 6000; // + Math.random() * 1000;
	        setTimeout(doChangeMessage,randomTimeout);
	    }
	};
	
	Loader.prototype.afterDone = function(callback){
	    var that = this;
	    this.callback  = callback;
	
	    document.querySelector('.loaderContainer').addEventListener("click",this.callback);
	    clearTimeout(this.changeMessageTimeout);
	
	    that.messageEl.classList.add("waitForDone");
	
	    var divs = document.querySelectorAll('.loader div');
	    var divCount = 0;
	    [].forEach.call(divs, function(el) {
	        WebUtils.one(el,"animationiteration webkitAnimationIteration",function(){
	            el.classList.add("done");
	            divCount++;
	            if (divCount == divs.length){
	                that.messageEl.innerHTML = "Create World";
	                document.querySelector('.loaderContainer').classList.add("done");
	            }
	        })
	    });
	
	};
	
	Loader.prototype.nextMessage = function(){
	    var that = this;
	    var messageText;
	
	    if (this.currentMessageIndex == null){
	        this.currentMessageIndex = WebUtils.getRandomInt(0, loadingMessages.length);
	        messageText = getMessageText(this.currentMessageIndex);
	        setMessage.call(this, messageText);
	        if (this.currentMessageSequenceIndex != null){
	            this.currentMessageSequenceIndex++;
	        }
	    }
	    else if (this.currentMessageSequenceIndex === null){
	        var lastMessageIndex = this.currentMessageIndex;
	        var newMessageIndex = WebUtils.getRandomInt(0, loadingMessages.length);
	        while(newMessageIndex == lastMessageIndex){
	            newMessageIndex = WebUtils.getRandomInt(0, loadingMessages.length);
	        }
	        this.currentMessageIndex = newMessageIndex;
	        messageText = getMessageText(this.currentMessageIndex);
	        setMessage.call(this, messageText);
	        if (this.currentMessageSequenceIndex != null){
	            this.currentMessageSequenceIndex++;
	        }
	    }
	    //more messages in the queue
	    else if (this.currentMessageSequenceIndex < loadingMessages[this.currentMessageIndex].length){
	            setMessage.call(this, loadingMessages[this.currentMessageIndex][this.currentMessageSequenceIndex]);
	            this.currentMessageSequenceIndex++;
	        }
	    else{
	        //we're at the last line
	        this.currentMessageSequenceIndex = null;
	        this.nextMessage();
	    }
	    
	    function getMessageText(index){
	        that.currentMessageIndex = index;
	        if (Array.isArray(loadingMessages[index])){
	            that.currentMessageSequenceIndex = 0;
	
	            return loadingMessages[index][0];
	        }
	        else{
	            that.currentMessageSequenceIndex = null;
	            return loadingMessages[index];
	        }
	    }
	};
	
	function setMessage(text){
	    var that = this;
	    document.querySelector(".loaderContainer").classList.toggle("alternate");
	
	    WebUtils.one(this.messageEl, "transitionend",function(){
	        that.messageEl.innerHTML = text;
	
	        document.querySelector(".loaderContainer .caption").style.transitionDelay = "2.3s";
	        that.messageEl.style.opacity = 0.7;
	
	        WebUtils.one(that.messageEl, "transitionend",function() {
	            that.messageEl.style.opacity = null;
	            document.querySelector(".loaderContainer .caption").style.transitionDelay = "0s";
	        });
	    });
	
	    this.messageEl.style.opacity = 0;
	}
	
	module.exports = Loader;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	if (!String.prototype.format) {
	    String.prototype.format = function() {
	        var args = arguments;
	        return this.replace(/{(\d+)}/g, function(match, number) {
	            return typeof args[number] != 'undefined'
	                ? args[number]
	                : match
	                ;
	        });
	    };
	}
	
	
	function _clone(obj) {
	    // Handle the 3 simple types, and null or undefined
	    if (null == obj || "object" != typeof obj) return obj;
	
	    // Handle Date
	    if (obj instanceof Date) {
	        var copy = new Date();
	        copy.setTime(obj.getTime());
	        return copy;
	    }
	
	    // Handle Array
	    if (obj instanceof Array) {
	        var copy = [];
	        for (var i = 0, len = obj.length; i < len; i++) {
	            copy[i] = _clone(obj[i]);
	        }
	        return copy;
	    }
	
	    // Handle Object
	    if (obj instanceof Object) {
	        var copy = {};
	        for (var attr in obj) {
	            if (obj.hasOwnProperty(attr)) copy[attr] = _clone(obj[attr]);
	        }
	        return copy;
	    }
	
	    throw new Error("Unable to copy obj! Its type isn't supported.");
	}
	
	function _extend(obj) {
	    var clone=_clone(this);
	    for(var i in obj){
	        clone[i] = obj[i];
	    }
	    return clone;
	}
	
	function _generateGuid(prefix){
	    prefix=prefix?prefix+"_":"";
	    var S4 = function() {
	        return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
	    };
	    return (prefix+S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
	}
	
	
	function _drawSvgLine(path,options){
	    var defaultOpts={
	        strokeLength: 5,
	        delay: "0s",
	        speed: "2s",
	        marchingAnts: true
	    };
	
	    path.style.display="block";
	    var options=_extend.call(defaultOpts,options);
	    var length = path.getTotalLength();
	    // Clear any previous transition
	    path.style.transition = path.style.WebkitTransition =
	        'none';
	    // Set up the starting positions
	    var offsetString="";
	    var strokeLength=options.strokeLength;
	    for(var x=0;x<length/(strokeLength*2);x++){
	        offsetString=offsetString+"{0} {0} ".format(strokeLength,strokeLength);
	    }
	    offsetString+=" 0 "+length;
	    path.style.strokeDasharray = offsetString;
	    path.style.strokeDashoffset = length;
	    // Trigger a layout so styles are calculated & the browser
	    // picks up the starting position before animating
	    path.getBoundingClientRect();
	    //callback for after transition end
	
	
	    _one(path,"transitionend",function(){
	        path.style.transition = path.style.WebkitTransition = '';
	        path.style.strokeDasharray=options.strokeLength;
	        if (options.marchingAnts){
	            path.classList.add("marchingAnts");
	        }
	        if (options.callback){
	            options.callback.call(path);
	        }
	    });
	
	
	    // Define our transition
	    path.style.transition = path.style.WebkitTransition =
	        'stroke-dashoffset {0} ease-in {1}'.format(options.speed,options.delay);
	    // Go!
	    path.style.strokeDashoffset = '0';
	}
	
	var _one = function(object,event,callback){
	    var handle={};
	
	    var eventNames=event.split(" ");
	
	    var cbWrapper=function(){
	        eventNames.forEach(function(e){
	            object.removeEventListener(e,cbWrapper, false );
	        });
	        callback.apply(this,arguments);
	    };
	
	    eventNames.forEach(function(e){
	        object.addEventListener(e,cbWrapper,false);
	    });
	
	    handle.cancel=function(){
	        eventNames.forEach(function(e){
	            object.removeEventListener(e,cbWrapper, false );
	        });
	    };
	
	    return handle;
	};
	
	function _shuffle(array) {
	    array = array.slice(0);
	    var tmp, current, top = array.length;
	
	    if(top) while(--top) {
	        current = Math.floor(Math.random() * (top + 1));
	        tmp = array[current];
	        array[current] = array[top];
	        array[top] = tmp;
	    }
	
	    return array;
	}
	
	function _isNumeric(n) {
	    return !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	function _getUrlVars() {
	    var query_string = {};
	    var query = window.location.search.substring(1);
	    var vars = query.split("&");
	    for (var i=0;i<vars.length;i++) {
	        var pair = vars[i].split("=");
	        // If first entry with this name
	        if (typeof query_string[pair[0]] === "undefined") {
	            query_string[pair[0]] = pair[1];
	            // If second entry with this name
	        } else if (typeof query_string[pair[0]] === "string") {
	            var arr = [ query_string[pair[0]], pair[1] ];
	            query_string[pair[0]] = arr;
	            // If third or later entry with this name
	        } else {
	            query_string[pair[0]].push(pair[1]);
	        }
	    }
	    return query_string;
	}
	
	function _isMobile () {
	    var check = false;
	    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
	    return check;
	}
	
	function _getRandomInt(min, max) {
	    return Math.floor(Math.random() * (max - min)) + min;
	}
	
	String.prototype.hashCode = function() {
	    var hash = 0, i, chr, len;
	    if (this.length == 0) return hash;
	    for (i = 0, len = this.length; i < len; i++) {
	        chr   = this.charCodeAt(i);
	        hash  = ((hash << 5) - hash) + chr;
	        hash |= 0; // Convert to 32bit integer
	    }
	    return hash;
	};
	
	module.exports = {
	    extend: _extend,
	    clone: _clone,
	    generateGuid: _generateGuid,
	    drawSvgLine: _drawSvgLine,
	    one: _one,
	    shuffle: _shuffle,
	    isNumeric: _isNumeric,
	    getRandomInt: _getRandomInt,
	    isMobile: _isMobile,
	    getUrlVars: _getUrlVars
	};


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.js